import { render, staticRenderFns } from "./approveRecords.vue?vue&type=template&id=75403a4a&"
import script from "./approveRecords.vue?vue&type=script&lang=js&"
export * from "./approveRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports